import { passCodes } from '../passCodes';
import { zdarCustomCiphers } from '../zdarEscapeGameCustomCiphers';

const hints = [
    {
        text: 'slepice, vrabec, straka',
    },
    {
        text: 'labuť, kachna, sokol, orlice, holubice, datel',
    },
    {
        text: 'Kódem je: orlice',
        solution: true,
    },
];
export const step31king = {
    id: 29,
    title: '14. stanoviště',
    taskText: `
        <p>
            Paráda, máme číslo! Ale ještě to nekončí. Než se pohneme dál, musíme si připomenout, jaký všechny ptáky jsme na naší cestě potkali. Vyplň tuhle šifru a budeme moct pokračovat.
        </p>
    `,
    catImage: 4,
    cipher: {
        label: 'Úkol',
        custom: zdarCustomCiphers.birds,
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[22],
    additionalInfo: 'Odpovědí je jedno slovo.',
    hints: hints,
    snowHints: hints,
};
